import React from 'react'
import HeaderMainPage from '../Auth/Header/HeaderMainPage';
import { useLanguageStore } from '../../store/useLanguageStore';
import { useDarkModeStore } from '../../store/useDarkModeStore';

export const AboutUs = () => {
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();

    const texts = ['AboutUsPart1', 'AboutUsPart2', 'AboutUsPart3'];

    return (
        <div className="w-100 vh-100 d-flex flex-column">
            <HeaderMainPage />
            <div className='w-100 h-100 d-flex flex-column align-items-center justify-content-center p-5'>
                <h1 className='main-header-color fw-bold'>{language['AboutUs']}</h1>
                <div className={`w-75 mt-3 ${darkMode && 'text-white'}`}>
                    {
                        texts.map(i =>
                            <p key={i} className='text-center mb-3'>{language[i]}</p>
                        )
                    }
                </div>
            </div>
        </div>
    );
}
export default AboutUs;